import { Injectable, Inject } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { ENV } from "../environments/environment-variables.token";
// import { reject } from 'q';
import { Observable } from "rxjs";
import "rxjs/add/operator/map";
import {MatSnackBar} from "@angular/material/snack-bar";
import { SessionStorageService } from "angular-web-storage";
// import { ENV } from '../environments/environment-variables.token';

@Injectable({
	providedIn: "root"
})
export class HttpService {
	private model: Array<any>;
	public user: any;
	private token: any;
	private count = 0;

	public activeModal: any;
	public delay: any;
	constructor(
		private http: HttpClient,
		private snackBar: MatSnackBar,
		private session: SessionStorageService,
		// tslint:disable-next-line:no-shadowed-variable
		@Inject(ENV) public ENV: any
	) { }



	get(path: string, auth: boolean = true): any {
		if (!auth) {
			return this.request(path, "get", false);
		} else {
			return this.getToken().then(() => {
				return this.request(path, "get", true);
			});
		}
	}

	post(path: string, auth: boolean = true, data: any): any {
		if (!auth) {
			return this.request(path, "post", false, data);
		} else {
			return this.getToken().then(() => {
				return this.request(path, "post", true, data);
			});
		}
	}

	getToken(): any {
		return new Promise((resolve, reject) => {
			this.token = localStorage.getItem("currentUser_token");
			// const temp = JSON.parse(sessionStorage.getItem("currentUser_token"));
			// this.token = temp ? temp._value : "";
			resolve(this.token);
		}).catch(err => console.log("Error trying to get token: ", err));
	}
	setToken(token: string): any {
		return new Promise((resolve, reject) => {
			localStorage.setItem("currentUser_token", token);
			// this.session.set("currentUser_token", token, 2, "h");
			this.token = token;
			resolve(true);
		}).catch(err => console.log("Error trying to set token: ", err));
	}

	request(path: string, method: string, auth: boolean, data: any = {}): any {
		console.log("this.ENV.API_URL", this.ENV.API_URL);
		console.log("path", path);
		if(!this.ENV.API_URL) { this.ENV.API_URL = "https://apihmlg.youdoctor.com.br";}
		const url: string = String(this.ENV.API_URL) + "/" + String(path);
		const headers: any = {};
		headers["Content-Type"] = "application/json";
		if (auth) {
			headers.Authorization = this.token;
		}

		let params: Array<any>;

		if (method === "post") {
			params = [url, data, { headers }];

		} else {
			params = [url, { headers }];
		}
		// console.log("parans", params);

		if (this.count < 1) { this.showLoader(); }
		this.count++;
		return new Promise((resolve, reject) => {
			this.http[method](...params)
				.map(res => {
					// workaround handle for API problems
					return res._body === "" ? {} : res;
				})
				.subscribe(res => {
					this.count--;
					if (this.count === 0) { setTimeout(() => { this.hideLoader(); }, 1000); }
					resolve(res);
					// loading.dismiss();
				}, (err) => {
					this.count--;
					if (this.count === 0) { setTimeout(() => { this.hideLoader(); }, 1000); }
					// if (err.error.message) {this.openSnackBar(err.error.message); } else if (err.message) {this.openSnackBar(err.message); }
					// console.log("Error on request method (http service): ", err);
					if (err.error.message) return reject(err.error.message)
					reject(err);
					// loading.dismiss();
				});
		});
	}
	openSnackBar(message: string, action: string = "OK", duration = 4000, ) {
		this.snackBar.open(message, action, {
		  duration,
		  verticalPosition: "top",
		});
	}
	showLoader(): void {
		this.ENV.loading = true;
	}
	hideLoader(): void {
		this.ENV.loading = false;
	}
}
